import { DocsEntityApprovalState } from "./SDKDocsEntityApprovalState";
import { DocsEntityConfiguration } from "./SDKDocsEntityConfiguration";
import { DocsEntityDraftState } from "./SDKDocsEntityDraftState";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocsEntity {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e;
        this.parent = null;
        this.id = model.id;
        this.persistentId = model.persistentId;
        this.type = model.type;
        this.configuration = model.configuration
            ? new DocsEntityConfiguration(model.configuration, model.title)
            : null;
        this.slug = (_a = model.slug) !== null && _a !== void 0 ? _a : "";
        this.userSlug = (_b = model.userSlug) !== null && _b !== void 0 ? _b : null;
        this.title = model.title;
        this.createdAt = model.createdAt ? new Date(model.createdAt) : null;
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : null;
        this.draftState = model.draftState
            ? new DocsEntityDraftState(model.draftState)
            : null;
        this.isPrivate = Boolean((_c = model.configuration) === null || _c === void 0 ? void 0 : _c.isPrivate);
        this.isHidden = Boolean((_d = model.configuration) === null || _d === void 0 ? void 0 : _d.isHidden);
        this.publishMetadata = (_e = model.publishMetadata) !== null && _e !== void 0 ? _e : null;
        this.approvalState = new DocsEntityApprovalState(model.approvalState || null, this.draftState);
    }
}
